import React from 'react';

import { useMediaQuery, useTheme } from '@mui/material';
import logo_footer from '../../../assets/MyBakeOven_White.svg';
import LinksFooter, {
  LinksFooterProps,
} from '../../../../../components/App/footer/LinksFooter/LinksFooter';

function LinksFooterMyBakery(props: LinksFooterProps) {
  const theme = useTheme();
  const isTablet = useMediaQuery(theme.breakpoints.down('md'));
  const { logoFooter = logo_footer } = props;
  return (
    <LinksFooter logoFooter={logoFooter} logoHeight={isTablet ? 20 : 30} />
  );
}

export default LinksFooterMyBakery;
